module.exports = __webpack_public_path__ + "img/news-off-grid-pic.png?5ff86de750eeaaefd43b4bba3df835ba";